export type Tip = {
  heading: string
  body: string
}

export const tips: Tip[] = [
  {
    heading: 'HOW TO PREPARE FOR A KITCHEN REMODEL',
    body: 'Before requesting an estimate, make a list of what is not working in your current kitchen. Consider storage, counter space, lighting, traffic flow and appliance locations. Collect a few inspiration photos and separate your must-haves from optional upgrades. Having clear priorities helps your contractor create a practical design and an accurate estimate.',
  },
  {
    heading: 'WHAT TO CONSIDER BEFORE REMODELING A BATHROOM',
    body: 'A successful bathroom remodel involves more than selecting tile and fixtures. Consider ventilation, lighting, storage, accessibility and the condition of the plumbing behind the walls. Addressing moisture problems and outdated materials early can help prevent expensive repairs later. A professional evaluation can also determine whether your planned layout changes are practical.',
  },
  {
    heading: 'WHY BATHROOM VENTILATION MATTERS',
    body: 'A properly sized and vented bathroom exhaust fan helps remove moisture created by showers and baths. Without adequate ventilation, excess humidity can contribute to peeling paint, damaged drywall and mold growth. The fan should vent outdoors—not into an attic or other enclosed area—and should be allowed to run after the bathroom has been used.',
  },
  {
    heading: 'PLANNING A REMODEL DURING A MICHIGAN WINTER',
    body: 'Many interior remodeling projects can be completed throughout the winter. Kitchens, bathrooms and basements are especially well suited for colder months, but homeowners should plan for material deliveries, temporary loss of certain rooms and controlled access through the home. Starting the planning process early also provides time to finalize selections and order materials before construction begins.',
  },
]
